import React from "react";
import ShowcaseCard, { IShowcaseCard } from "./ShowcaseCard";
import { RefreshIcon } from "components/icons";

type ICommunityShowcaseProps = {
  data: IShowcaseCard[];
  onlineCount: number;
  onSelected: (card: IShowcaseCard) => void;
  onRefreshOnlineCount?: () => void;
};

const CommunityShowcase: React.FC<ICommunityShowcaseProps> = ({
  data,
  onlineCount,
  onSelected,
  onRefreshOnlineCount,
}) => {
  return (
    <div className="bg-[#DBEAFE] p-4 rounded-lg border-[0.6px] border-solid border-[#94A3B8] md:p-4 md:mt-3">
      {/* Header */}
      <div className="flex flex-col ">
        <div className="flex flex-row items-center justify-between">
          <h2 className="text-[16px] font-semibold text-[#171717] mb-1.5">
            Community Showcase 😎
          </h2>

          <button
            className="text-[#4338CA] flex items-center gap-[10px] hover:bg-[#4338CA] hover:text-white p-2 rounded transition-all duration-300"
            onClick={onRefreshOnlineCount}
          >
            <span className="text-[14px] font-medium">Refresh</span>
            <RefreshIcon />
          </button>
        </div>
        <p className="text-[#737373] text-[14px] mb-[18px]">
          See what others are creating and get inspired...
        </p>
      </div>

      {/* Cards */}
      <div className="space-y-[10px]">
        {data.map((card, index) => (
          <ShowcaseCard
            key={`${card.username}-${index}`}
            cardItem={card}
            onSelected={() => onSelected(card)}
          />
        ))}
      </div>

      {/* Footer */}
      <div className="flex justify-between items-center mt-[18px]">
        <p className="text-[#171717] text-[14px] font-medium flex flex-row items-center gap-[10px]">
          <span className="inline-block w-2 h-2 rounded-[8px] bg-[#81D69D]"></span>
          {onlineCount} people creating right now
        </p>
      </div>

    </div>
  );
};

export default CommunityShowcase;
